import { AppState } from '@Redux/store';
import { UnitCategory } from '@Models';

export const getUnitCategories = (state: AppState): UnitCategory[] =>
  state.armyCategory.entity?.units ?? [];
